import { useState } from 'react'
import styled from 'styled-components'
import { colors } from '../utils/config'
import { Button } from '@bm-js/atlascloud-ui'
import Input from './Input'
import { AnyObject } from '@naturalcycles/js-lib/types'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

const StyledDeleteConfirmation = styled.div`
  .field {
    margin-top: 1rem;
    margin-bottom: 1rem;
    background: ${colors.gray400};
    display: inline-block;
    font-family: monospace;
    font-size: 1rem;
    padding: 0.5rem;
  }
`

type Props<T extends AnyObject> = {
  item: T
  deleteKey: keyof T
  name: string
  handleDelete: (item: T, cb: () => void) => void | Promise<void>
  handleCancel: () => void
}

const DeleteConfirmation = <T extends AnyObject>({
  item,
  deleteKey,
  name,
  handleDelete,
  handleCancel,
}: Props<T>) => {
  const { tr } = useTr()
  const [textval, setTextval] = useState('')
  const [errMsg, setErrMsg] = useState('')
  const [loading, setLoading] = useState(false)
  const isValid = item[deleteKey] === textval

  const handler = () => {
    if (!isValid) return setErrMsg(tr(TrKey.deleteConfirmationMismatch))
    setLoading(true)
    handleDelete(item, () => setLoading(false))
  }

  return (
    <StyledDeleteConfirmation>
      <h2 className='m0 primblue m'>
        {tr(TrKey.delete)} {name}?
      </h2>
      <p className='m0 mtop1'>{tr(TrKey.deleteConfirmationText)}</p>
      <p className='field'>{item[deleteKey]}</p>
      <Input
        value={textval}
        onChange={(e) => setTextval(e.target.value)}
        type='text'
        disabled={loading}
      />
      {errMsg && <p className='m0 danger'>{errMsg}</p>}
      <div className='ac jce gap05 mtop1 flex'>
        <Button danger onClick={handler} disabled={!isValid || loading}>
          {tr(TrKey.delete)}
        </Button>
        <Button onClick={handleCancel} disabled={loading}>
          {tr(TrKey.cancel)}
        </Button>
      </div>
    </StyledDeleteConfirmation>
  )
}

export default DeleteConfirmation
